/**
 * @Author     : Fanng(fanng@live.com)
 * @CreateTime : 28/3/2017 11:16 AM
 */
import axios from "axios";
import * as Cookies from "js-cookie";
import { MessageBox } from "element-ui";
export const baseURL = process.env.NODE_ENV === "production" ? "https://p.711.cn/api/" : "http://127.0.0.1:9998/api/";

export default function install(Vue, router) {
    Object.defineProperty(Vue.prototype, "$http", {
        get() {
            let $router = router.currentRoute;
            /**
             * Create Axios
             */
            var http = axios.create({
                baseURL: baseURL,
                withCredentials: true,
            });

            http.defaults.headers.common = {
                "X-ORG-ID": window.config.org_id,
            };

            http.interceptors.response.use(
                (response) => {
                    return response.data;
                },
                (error) => {
                    const { response } = error;
                    if (typeof response != "undefined") {
                        switch (response.status) {
                            case 401:
                                if ($router.meta.verify) {
                                    // MessageBox.alert(response.data.message||'账户状态验证失败，请重新登录。', '验证失败', {
                                    //     closeOnClickModal: false,
                                    //     closeOnPressEscape: false,
                                    //     showClose: false,
                                    //     type: 'error',
                                    //     callback: () => {

                                    //     }
                                    // })

                                    window.location.href = "/login?url_callback=" + encodeURI(document.URL);
                                } else {
                                    return response.data;
                                }
                                break;
                            case 403:
                            case 404:
                                //     window.location.href = "/login?url_callback=" + encodeURI(document.URL)
                                //     break;
                                // case 404:
                                MessageBox.confirm("你所访问的内容或者页面不存在，请确认无误后重新访问。", "404", {
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false,
                                    showClose: false,
                                    cancelButtonText: "返回首页",
                                    confirmButtonText: "返回上一页",
                                    type: "error",
                                    callback: (action) => {
                                        if (action === "confirm") {
                                            return window.history.back(-1);
                                        } else {
                                            return (window.location.href = "/");
                                        }
                                    },
                                });
                                break;
                            default:
                                return response.data;
                        }
                    } else {
                        MessageBox.alert("当前网络可能存在异常，请确认没有问题后重新登录网站，或者刷新网页。", "请求失败", {
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                            showClose: false,
                            type: "error",
                            callback: () => {
                                if (window.location.pathname != "/login") {
                                    //window.location.href = "/login?url_callback=" + encodeURI(document.URL)
                                }
                            },
                        });

                        return {};
                    }
                }
            );
            return http;
        },
    });
}
